import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import MaterialTable, { MTableBody } from 'material-table';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import Refresh from '@material-ui/icons/Refresh';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { ApplicationState, SubmissionState } from '../models/ApplicationState';
import { submissionRequest, deleteSubmission, getColumnConfig } from '../state/submission/submissionDataActions';
import { SubmissionRequestModel, GridActions, GetColumnConfigPayload } from '../models/SubmissionModel';
import EditFormDialog from './dialogs/EditFormDialog';
import ViewFormDialog from './dialogs/ViewFormDialog';
import DeleteSubmissionDialog from './dialogs/DeleteSubmissionDialog';
import {
  showViewFormDialog, showEditFormDialog, showDeleteRecordDialog,
  closeViewFormDialog, closeEditFormDialog, closeDeleteRecordDialog
} from '../state/submission/submissionDataActions';
import ApplicationDataService from './../service';
const config = require(`.././config.${process.env.NODE_ENV}.json`);

export interface DeleteRecordPayload {
  gridData: any;
  dataToBeDeleted: any;
}

export interface Localization {
  body: {};
  header: {};
  toolbar: {};
  pagination: {};
  viewTooltip: string;
  editTooltip: string;
  deleteTooltip: string;
  selectTooltip: string;
  refreshDataTooltip: string;
}

export interface OwnProps {
  title?: string;
  data?: any;
  columns: any;
  formAlias: string;
  listAlias: string
  options?: any;
  remoteDataUrl?: string;
  filters?: any;
  view?: () => void;
  edit?: () => void;
  delete?: (data: DeleteRecordPayload) => void;
  onRowSelect?: (event: any, rowData: any, togglePanel: any) => void;
  classes: any;
  i18n: Localization;
  privileges: any;
  formOptions: any;
  actions?: GridActions[];
  selectedLanguage: string;
  onSelectionChange?: (rows: any) => void;
  components?: React.ReactElement
  remoteDataFunc?: (query: any) => void;
  showRefresh: boolean;
  loaderComponent?: React.ReactElement,
  onChangeRowsPerPage: (pageSize: number) => void;
  clearDefaultfilters?: boolean
}

const defaultI18n: any = {
  gridTitle: {
    en: 'Donation Requests',
    es: 'Solicitudes de donación'
  },
  createNewBtnLable: {
    en: 'Create New',
    es: 'Crear nueva'
  },
  backBtnLabel: {
    en: 'Back',
    es: 'atrás'
  },
  gridLocalization: {
    en: {
      pagination: {
        labelDisplayedRows: '{from}-{to} of {count}',
        labelRowsSelect: 'rows',
        labelRowsPerPage: 'Rows per page: ',
        firstAriaLabel: 'First Page',
        firstTooltip: 'First Page',
        previousAriaLabel: 'Previous Page',
        previousTooltip: 'Previous Page',
        nextAriaLabel: 'Next Page',
        nextTooltip: 'Next Page',
        lastAriaLabel: 'Last Page',
        lastTooltip: 'Last Page'
      },
      toolbar: {
        exportTitle: 'Export',
        exportAriaLabel: 'Export',
        exportName: 'Export as CSV',
        searchTooltip: 'Search',
        searchPlaceholder: 'Search',
        nRowsSelected: '{0} record(s) selected, Please take action on selected records'
      },
      header: {
        actions: 'Actions'
      },
      body: {
        emptyDataSourceMessage: 'No records to display',
        filterRow: {
          filterTooltip: 'Filter'
        }
      },
      viewTooltip: 'Click to view details',
      editTooltip: 'Edit details',
      deleteTooltip: 'Delete',
      refreshDataTooltip: 'Refresh Data',
    },
    es: {
      pagination: {
        labelDisplayedRows: '{from} - {to} de {count}',
        labelRowsSelect: 'filas ',
        labelRowsPerPage: 'Filas por página:',
        firstAriaLabel: 'Primera página',
        firstTooltip: 'Primera página',
        previousAriaLabel: 'Pagina anterior',
        previousTooltip: 'Pagina anterior',
        nextAriaLabel: 'Siguiente página',
        nextTooltip: 'Siguiente página',
        lastAriaLabel: 'Última página',
        lastTooltip: 'Última página'
      },
      toolbar: {
        exportTitle: 'Exportar',
        exportAriaLabel: 'Exporta',
        exportName: 'Exportar como CSV',
        searchTooltip: 'Buscar',
        searchPlaceholder: 'Buscar',
        nRowsSelected: '{0} record(s) selected, Please take action on selected records'
      },
      header: {
        actions: 'Comportamiento'
      },
      body: {
        emptyDataSourceMessage: 'No hay registros que mostrar',
        filterRow: {
          filterTooltip: 'Filtrar'
        }
      },
      viewTooltip: 'Click to view details sp',
      editTooltip: 'Edit details sp',
      deleteTooltip: 'Delete sp',
      refreshDataTooltip: 'Refresh Data sp',
    }
  }
}
export interface DispatchProps {
  getSubmissions: (data: SubmissionRequestModel) => void;
  deleteSubmission: (data: any) => void;
  openViewFormDialog: () => void;
  openEditFormDialog: () => void;
  openDeleteRecordDialog: () => void;
  closeViewFormDialog: () => void;
  closeEditFormDialog: () => void;
  closeDeleteRecordDialog: () => void;
  getColumnConfig: (data: GetColumnConfigPayload) => void;
}

const tableIcons = {
  Add: React.forwardRef((props, ref: any) => <AddBox {...props} ref={ref} />),
  Check: React.forwardRef((props, ref: any) => <Check {...props} ref={ref} />),
  Clear: React.forwardRef((props, ref: any) => <Clear {...props} ref={ref} />),
  Delete: React.forwardRef((props, ref: any) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: React.forwardRef((props, ref: any) => <ChevronRight {...props} ref={ref} />),
  Edit: React.forwardRef((props, ref: any) => <Edit {...props} ref={ref} />),
  Export: React.forwardRef((props, ref: any) => <SaveAlt {...props} ref={ref} />),
  Filter: React.forwardRef((props, ref: any) => <FilterList {...props} ref={ref} />),
  FirstPage: React.forwardRef((props, ref: any) => <FirstPage {...props} ref={ref} />),
  LastPage: React.forwardRef((props, ref: any) => <LastPage {...props} ref={ref} />),
  NextPage: React.forwardRef((props, ref: any) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: React.forwardRef((props, ref: any) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: React.forwardRef((props, ref: any) => <Clear {...props} ref={ref} />),
  Search: React.forwardRef((props, ref: any) => <Search {...props} ref={ref} />),
  SortArrow: React.forwardRef((props, ref: any) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: React.forwardRef((props, ref: any) => <Remove {...props} ref={ref} />),
  ViewColumn: React.forwardRef((props, ref: any) => <VisibilityIcon {...props} ref={ref} />),
  Refresh: React.forwardRef((props, ref: any) => <Refresh {...props} ref={ref} />)
};
class SubmissionGridComponent extends React.PureComponent<OwnProps & DispatchProps & SubmissionState> {

  private filterRef: React.RefObject<any>;
  private tableRef: React.RefObject<any>;
  private actions: any[] = [];
  private i18n: any;
  constructor(props: Readonly<OwnProps & DispatchProps & SubmissionState>) {
    super(props);
    this.tableRef = React.createRef();
    this.filterRef = React.createRef();
  }

  public state = {
    submissionForEdit: {},
    submissionsForView: {},
    submissionToBeDeleted: {},
    actions: [],
    columns: [],
    tableProps: '',
    pageSize: 10
  }

  public UNSAFE_componentWillMount() {
    this.i18n = this.props.i18n || defaultI18n;
    this.getActions(this.props);
    if (!this.props.data && !this.props.remoteDataUrl && !this.props.remoteDataFunc) {
      this.props.getSubmissions({
        listAlias: this.props.listAlias,
        query: this.props.filters
      });
    }
    if (this.props.columns.length === 0 && this.props.remoteDataFunc === undefined) {
      this.props.getColumnConfig({
        listAlias: this.props.listAlias,
      });
    } else {
      const columns: any[] = [];
      this.props.columns.map((column: any) => {
        columns.push({
          ...column,
          title: column.title ? column.title[this.props.selectedLanguage] : ''
        })
      })
      this.setState({ columns })
    }
  }

  public UNSAFE_componentWillReceiveProps(newProps: any) {
    this.i18n = this.props.i18n || defaultI18n;
    this.getActions(newProps);
    if (newProps.listAlias !== this.props.listAlias) {
      if (newProps.columns.length === 0) {
        this.props.getColumnConfig({
          listAlias: newProps.listAlias,
        });
      }
    }
    const columns: any[] = [];
    if ((this.props.columns !== newProps.columns && newProps.columns.length > 0) ||
      (newProps.selectedLanguage !== this.props.selectedLanguage &&
        this.props.columnConfig !== newProps.columnConfig && this.props.columnConfig.length === 0)) {
      newProps.columns.map((column: any) => {
        columns.push({
          ...column,
          title: column.title ? column.title[newProps.selectedLanguage] : ''
        })
      })
      this.setState({ columns })
      // console.log('in if case of submission grid columns--->', columns)
    } else if ((this.props.columns && this.props.columns.length === 0 &&
      this.props.columnConfig !== newProps.columnConfig) ||
      (newProps.selectedLanguage !== this.props.selectedLanguage)) {
      newProps.columnConfig.map((column: any) => {
        columns.push({
          ...column,
          title: column.title ? column.title[newProps.selectedLanguage] : ''
        })
      })
      this.setState({ columns })
      // console.log('in else case of submission grid columns--->', columns)
    }
  }

  public componentWillUnmount() {
    this.setState({
      columns: []
    })
  }
  private getActions = (props: OwnProps) => {
    let actions: any[] = [];
    if (props.actions) {
      actions = actions.concat(props.actions);
    }
    else {
      if (props.privileges && props.privileges.viewable) {
        actions.push({
          icon: tableIcons.ViewColumn,
          tooltip: this.i18n.gridLocalization[props.selectedLanguage].viewTooltip,
          onClick: (_event: any, rowData: any) => this.viewForm(rowData)
        })
      }
      if (props.privileges && props.privileges.editable) {
        actions.push({
          icon: tableIcons.Edit,
          tooltip: this.i18n.gridLocalization[props.selectedLanguage].editTooltip,
          onClick: (_event: any, rowData: any) => this.editForm(rowData)
        })
      }
      if (props.privileges && props.privileges.removable) {
        this.actions.push({
          icon: tableIcons.Delete,
          tooltip: this.i18n.gridLocalization[props.selectedLanguage].deleteTooltip,
          onClick: (_event: any, rowData: any) => this.showDeleteDialog(rowData)
        })
      }
    }
    if (this.props.showRefresh) {
      actions.push({
        icon: tableIcons.Refresh,
        tooltip: this.i18n.gridLocalization[props.selectedLanguage].refreshDataTooltip,
        isFreeAction: true,
        onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
      })
    }

    this.setState({
      actions
    })
  }
  private filterChange = (columnId: any, value: any) => {
    // @ts-ignore
    this.state.tableProps.onFilterChanged(columnId, value);
    // @ts-ignore
    this.filterRef.current = value
  }
  private tableBody = (props: any) => {
    if (!this.state.tableProps) {
      this.setState({ tableProps: props })
    }
    return <MTableBody {...props} onFilterChanged={this.filterChange} />
  }
  private onChangeRowsPerPage = (pageSize: number) => {
    this.setState({ pageSize })
  }
  public render() {
    const submissions = this.props.submissions ? JSON.parse(JSON.stringify(this.props.submissions)) : [];
    const components = {
      Body: (props: any) => this.tableBody(props)
    }
    let onRowClickOption: any = {};
    if (this.props.onRowSelect) {
      onRowClickOption = {
        onRowClick: this.props.onRowSelect || this.onRowSelect
      }
    }
    let table;
    let stringParams: string;
    if (typeof this.props.filters === 'string') {
      stringParams = this.props.filters
    }
    if (this.props.remoteDataUrl) {
      table = <MaterialTable
        components={{
          ...components,
          ...this.props.components
        }}
        tableRef={this.tableRef}
        icons={tableIcons}
        options={{
          ...this.props.options,
          pageSize: this.props.options.pageSize ? this.props.options.pageSize : this.state.pageSize
        }}
        columns={this.state.columns}
        // tslint:disable-next-line: jsx-no-lambda
        data={(query: any) => {
          if (this.props.filters) {
            query.filters = [...query.filters, ...this.props.filters]
          }
          return ApplicationDataService.getSubmissions({
            remoteDataUrl: this.props.remoteDataUrl,
            pageNumber: query.page + 1,
            itemsPerPage: query.pageSize,
            query,
            stringParams,
          }).catch(e => {
            if (e.response && e.response.status === 401) {
              window.location.href = config.pingfedUrl;
            }
          })
        }
        }
        title={this.props.title}
        actions={this.state.actions}
        // @ts-ignore
        localization={this.i18n.gridLocalization[this.props.selectedLanguage]}
        {...onRowClickOption}
        onSelectionChange={this.props.onSelectionChange || this.onSelectionChange}
        onChangeRowsPerPage={this.props.onChangeRowsPerPage || this.onChangeRowsPerPage}
      />;
    } else if (this.props.remoteDataFunc) {
      table = <MaterialTable
        components={{
          ...components,
          ...this.props.components
        }}
        tableRef={this.tableRef}
        icons={tableIcons}
        options={{
          ...this.props.options,
          pageSize: this.props.options.pageSize ? this.props.options.pageSize : this.state.pageSize
        }}
        columns={this.state.columns}
        // tslint:disable-next-line: jsx-no-lambda
        data={(query: any) => {
          if (this.props.clearDefaultfilters) {
            const self = this.tableRef.current; // get the tableRef
            const newQuery = self.state.query; // get the query obj
            self.setState({
              ...self.dataManager.getRenderState(), // set the render state
              query: {
                ...newQuery,
                filters: [] // set filters to nothing
              }
            });
            // you also need to update the filter value on the column by doing this:
            const currentFilters = this.tableRef.current.state.query.filters;
            currentFilters.forEach((_item: any, index: number) => {
              const tableColumn = this.tableRef.current.state.query.filters[index].column
              tableColumn.defaultFilter = null
              this.tableRef.current.dataManager.changeFilterValue(tableColumn.tableData.id, null)
            })
          }
          // @ts-ignore
          return this.props.remoteDataFunc(query)
        }
        }
        title={this.props.title}
        actions={this.state.actions}
        // @ts-ignore
        localization={this.i18n.gridLocalization[this.props.selectedLanguage]}
        {...onRowClickOption}
        onSelectionChange={this.props.onSelectionChange || this.onSelectionChange}
        onChangeRowsPerPage={this.props.onChangeRowsPerPage || this.onChangeRowsPerPage}
      />;
    }
    else {
      table = <MaterialTable
        components={{
          ...components,
          ...this.props.components
        }}
        icons={tableIcons}
        options={{
          ...this.props.options,
          pageSize: this.props.options.pageSize ? this.props.options.pageSize : this.state.pageSize
        }}
        columns={this.state.columns}
        data={this.props.data || submissions}
        title={this.props.title}
        actions={this.state.actions}
        // @ts-ignore
        localization={this.i18n.gridLocalization[this.props.selectedLanguage]}
        {...onRowClickOption}
        onSelectionChange={this.props.onSelectionChange || this.onSelectionChange}
        onChangeRowsPerPage={this.props.onChangeRowsPerPage || this.onChangeRowsPerPage}
      />;
    }
    return (
      <div style={{ maxWidth: '100%' }}>
        <EditFormDialog title={this.props.title || ''}
          formAlias={this.props.formAlias}
          formSubmission={this.state.submissionForEdit}
          showDialog={this.props.showEditDialog}
          formOptions={this.props.formOptions}
          onClose={this.handleEditDialogClose} />

        <ViewFormDialog title={this.props.title || ''}
          formAlias={this.props.formAlias}
          formSubmission={this.state.submissionsForView}
          showDialog={this.props.showViewFormDialog}
          formOptions={this.props.formOptions}
          onClose={this.handleViewFormDialogClose} />

        <DeleteSubmissionDialog showDialog={this.props.showDeleteDialog} deleteRecord={this.deleteRecord}
          cancel={this.cancelDeleteRecord} />
        {table}
        {this.props.submissionDataLoading ? <>{this.props.loaderComponent}</> : <></>}
      </div>
    )
  }

  private editForm = (submission: any) => {
    this.setState({
      submissionForEdit: submission
    }, () => this.props.openEditFormDialog());
  }

  private viewForm = (submission: any) => {
    this.setState({
      submissionsForView: submission
    }, () => this.props.openViewFormDialog());
  }
  private onRowSelect = (event: any, rowData: any, togglePanel: any) => {
    if (this.props.onRowSelect) {
      this.props.onRowSelect(event, rowData, togglePanel);
    } else {
      // console.log('onRowSelect action not handled', rowData);
    }
  }
  private handleEditDialogClose = () => {
    this.setState({
      submissionForEdit: {}
    }, () => this.props.closeEditFormDialog());
  }

  private handleViewFormDialogClose = () => {
    this.setState({
      submissionsForView: {}
    }, () => this.props.closeViewFormDialog());
  }
  // @ts-ignore
  private showDeleteDialog = (submission: any) => {
    this.setState({
      submissionToBeDeleted: submission
    }, () => this.props.openDeleteRecordDialog());
  }

  private cancelDeleteRecord = () => {
    this.setState({
      submissionToBeDeleted: {}
    }, () => this.props.closeDeleteRecordDialog());
  }

  private deleteRecord = () => {
    if (this.props.delete) {
      this.props.delete({
        gridData: {
          formAlias: this.props.formAlias
        },
        dataToBeDeleted: this.state.submissionToBeDeleted
      });
    } else {
      this.props.deleteSubmission({
        gridData: {
          formAlias: this.props.formAlias
        },
        dataToBeDeleted: this.state.submissionToBeDeleted
      });
    }
  }

  private onSelectionChange = (_rows: any) => {
    // console.log('onSelectionChange not handle', rows);
  }
}

const mapDispactToProps = (dispatch: Dispatch<any>): DispatchProps => ({
  getSubmissions: (data: SubmissionRequestModel) => dispatch(submissionRequest(data)),
  deleteSubmission: (data: DeleteRecordPayload) => dispatch(deleteSubmission(data)),
  openViewFormDialog: () => dispatch(showViewFormDialog()),
  openEditFormDialog: () => dispatch(showEditFormDialog()),
  openDeleteRecordDialog: () => dispatch(showDeleteRecordDialog()),
  closeViewFormDialog: () => dispatch(closeViewFormDialog()),
  closeEditFormDialog: () => dispatch(closeEditFormDialog()),
  closeDeleteRecordDialog: () => dispatch(closeDeleteRecordDialog()),
  getColumnConfig: (data: GetColumnConfigPayload) => dispatch(getColumnConfig(data))
});

const mapStateToProps = (state: ApplicationState): SubmissionState => state.submissionState;

export default connect(mapStateToProps, mapDispactToProps)(SubmissionGridComponent);
